import React from "react";
import { compose } from "redux";
import { withStyles, IconButton } from "@material-ui/core";

import { Tile, TILE_CHIP_TYPES } from "altus-ui-components";
import AccessControl from "app/components/AccessControl";

const DashboardTile = ({
  chipLabel,
  chipType,
  children,
  classes,
  ActionButtonProps,
  ...rest
}) => (
  <Tile
    chipLabel={chipLabel}
    chipType={chipType}
    classes={{
      root: classes.root,
      chip: classes.chip,
    }}
    {...rest}
  >
    {!!ActionButtonProps && (
      <AccessControl accessLevel={ActionButtonProps.accessLevel}>
        <IconButton
          title={ActionButtonProps.title}
          className={classes.actionIconButton}
          onClick={ActionButtonProps.onClick}
        >
          {ActionButtonProps.renderIcon()}
        </IconButton>
      </AccessControl>
    )}
    {children}
  </Tile>
);

const styles = theme => ({
  root: {
    ...theme.altus.dashboard.tile,
    position: "relative",
  },
  chip: {
    border: 0,
    fontSize: theme.typography.h4.fontSize,
  },
  actionIconButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
});

DashboardTile.defaultProps = {
  chipLabel: 0,
  chipType: TILE_CHIP_TYPES.VISIBLE,
};

export default compose(withStyles(styles))(DashboardTile);
